import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";
import React from "react";
// import Login from "../features/Authentication/Login";
import Login from "../features/Authentication/NewLogin";
import PrivateRoute from "./PrivateRoute";
// import Partner from "../features/partner/partnerPage";
import ForgotPassword from "../features/Authentication/ForgotPassword";
import PageNotFound from "../components/reusableComponents/PageNotFound";
import Projects from "../features/projects/projectsPage";
import FormManagement from "../features/formManagement/fromManagementPage";
import Partner from "../features/partner/partnerPage";
import ImportForm from "../features/formBuilder/ImportForm";
import NewForm from "../features/formBuilder/NewForm";
const App = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <PrivateRoute path="/">
              <Login />
            </PrivateRoute>
          }
        />
        <Route path="/*" element={<PageNotFound />} />
        <Route path="/forgot_password" element={<ForgotPassword />} />
        <Route path="/page_not_found" element={<PageNotFound />} />
        <Route
          path="/users"
          element={
            <PrivateRoute>
              <Partner />
            </PrivateRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <PrivateRoute>
              <Projects />
            </PrivateRoute>
          }
        />
        <Route
          path="/import-form"
          element={
            <PrivateRoute>
              <ImportForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/new-form"
          element={
            <PrivateRoute>
              <NewForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/form_management"
          element={
            <PrivateRoute>
              <FormManagement />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
};
export default App;
